import React, { useEffect, useState } from "react";

import AnnualLeave from "../../views/admin/CustomAnnualLeave";

import CardLineChart from "components/Cards/CardLineChart.js";
import CardBarChart from "../../components/Cards/CardBarChart.js";
import CardStats from "../../components/Cards/CardStats";
import PageLoading from "../../helpers/PageLoading";
import { getError } from "../../store/helpers/common_functions";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { mapStateToProps } from "../../store/helpers/mapState";
import { useHistory } from "react-router";
import { Redirect } from "react-router-dom";
import { CheckHasPermission } from "helpers/Common_functions";

function Dashboard({
  FetchDetails,
  loggedUser,
  SetSelectedMenu,
  systemSettings,
}) {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState();
  const [info, setInfo] = React.useState();
  const [programData, setProgramData] = useState([]);

  const history = useHistory();

  const loadData = async () => {
    setLoading(true);
    setError(null);
    const resp = await FetchDetails("/api/dashboard/index/");

    const onboardedResp = await FetchDetails(
      "/api/resource/onboarded-employees"
    ); 

    // Fetch funders data to get accurate project count

    if (resp?.status && onboardedResp?.status) {
      // Calculate total funder projects from the funders API
      setInfo({
        ...resp.data,
        onboardedEmployees: onboardedResp.data, // Add onboarded and departed employees data
        funderProjects: resp.data.funderProjects, // Use the new field from the API
        partnerProjects: resp.data.partnerProjects, // Use the new field from the API
      });
    } else {
      setError(getError(resp));
    }
    setLoading(false);
  };

  useEffect(() => {
    const initializeDashboard = async () => {
      setLoading(true);
      setError(null);

      // Fetch dashboard data
      await loadData();

      // Fetch program details
      const response = await FetchDetails("/api/project/listAll");
      if (response.status) {
        setProgramData(response.data.data || []); // Ensure fallback to an empty array
      }

      // Set the selected menu
      SetSelectedMenu({
        menu: "dashboard",
        title: "Dashboard",
      });

      setLoading(false);
    };

    initializeDashboard();
  }, [FetchDetails, SetSelectedMenu]); // Combine dependencies into a single useEffect

  if (loggedUser?.id && !CheckHasPermission("menu.dashboard", "read")) {
    return <Redirect to={`/admin/profile/${loggedUser?.resourceId}`} />;
  }

  return (loading && !info) || error || !info ? (
    <PageLoading error={loading ? null : error} onRefresh={loadData} />
  ) : CheckHasPermission("menu.dashboard", "read") ? (
    <>
      {/* <div className="flex flex-wrap mb-4">

            <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
                <Paper
                    component="form"
                    sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
                >

                    <input
                        // sx={{ ml: 1, flex: 1 }}
                        className="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="Search by year"
                        // inputProps={{ 'aria-label': 'search year' }}
                        value={year}
                        // type="number"
                        maxLength={4}
                        minLength={4}
                        onChange={(e) => { setYear(e.target.value) }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault()
                                loadData()
                            }
                        }}
                    />
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={() => { loadData() }}>
                        <Search />
                    </IconButton>
                </Paper>

            </div>


    <div className={"mb-5"}>
      <div className="grid lg:grid-cols-5 grid-cols-2 gap-4">

      <div className={"mb-5"}>
        {/* Card stats */}

      <div className="grid lg:grid-cols-5 grid-cols-2 gap-4 mb-4">
        <div className="col-span-2 flex bg-white rounded mb-6 mt-6 xl:mb-0 shadow-lg px-2">


          {/* Divider line */}
          <CardStats
            statSubtitle={info.countingProjects ?? 0} // Total projects
            statSubtitleTitle={"Projects"}
            statTitle={info.countingCompletedProjects ?? 0} // Completed projects
            onClickFirst={() =>
              history.push("/admin/projects")
            }
            onClickSecond={() =>
              history.push("/admin/projects")
            }
            titleDescription="Ongoing Projects"
            statArrow="up"
            statPercent={info.countingInProgressProjects ?? 0} // In-progress projects
            statPercentColor="text-emerald-500"
            statDescripiron="Completed"
            statDescripironTitle="Ongoing"
            statIconName="ProjectIcon"
            statIconColor="bg-[#CBDCDC]"
            systemSettings={systemSettings}
          />
          <div className="border-l border-gray-300 mx-4 font-bold"></div>

          <CardStats
            statSubtitle={info.allActivitiesCount ?? 0}
            statSubtitleTitle={`Activities`}
            statTitle={info.completedActivitiesCount ?? 0} // Completed programs
            onClickFirst={() =>
              history.push("/admin/projects")
            }
            onClickSecond={() =>
              history.push("/admin/projects")
            }
            statArrow="up"
            statPercent={info.inProgressActivitiesCount ?? 0}
            cpns // In-progress programs
            statPercentColor="text-emerald-500"
            statDescripiron="Completed"
            statDescripironTitle="Ongoing"
            statIconName="ProgramIcon"
            statIconColor="bg-[#CBDCDC]"
            systemSettings={systemSettings}
          />
        </div>

        <CardStats
          statSubtitle={info.countingDepartments ?? 0}
          statSubtitleTitle={`Departments`}
          statTitle={info.countingDivisions ?? 0}
          onClickFirst={() =>
            history.push("/admin/if-structure", { status: "Divisions" })
          }
          onClickSecond={() =>
            history.push("/admin/if-structure", { status: "completed" })
          }
          titleDescription="Ongoing Projects"
          statArrow="up"
          statPercent=""
          statPercentColor="text-emerald-500"
          statDescripiron="Units"
          statDescripironTitle="Ongoing"
          statIconName="DepartmentIcon"
          statIconColor="bg-[#FFE3B3]"
          styles="bg-white rounded mb-6 mt-6 xl:mb-0 shadow-lg px-2"
          systemSettings={systemSettings}
        />
        <CardStats
          statSubtitle={info.countingFunders ?? 0}
          statSubtitleTitle={`Funders`}
          statTitle={info.funderProjects ?? 0} // Use the new field for total projects
          onClickFirst={() =>
            history.push("/admin/funders", { status: "Projects funded" })
          }
          onClickSecond={() =>
            history.push("/admin/funders", { status: "completed" })
          }
          titleDescription="Ongoing Projects"
          statArrow="up"
          statPercent=""
          statPercentColor="text-emerald-500"
          statDescripiron="Projects Funded"
          statDescripironTitle="Ongoing"
          statIconName="FunderIcon"
          statIconColor="bg-[#52B748]"
          styles="bg-white rounded mb-6 mt-6 xl:mb-0 shadow-lg px-2"
          systemSettings={systemSettings}
        />
        <CardStats
          statSubtitle={info.countingPartners ?? 0}
          statSubtitleTitle={`Implementing Partners`}
          statTitle={info.partnerProjects ?? 0} // Use the new field for total projects
          onClickFirst={() =>
            history.push("/admin/partners", { status: "Completed" })
          }
          onClickSecond={() =>
            history.push("/admin/partners", { status: "Ongoing" })
          }
          titleDescription="Ongoing Projects"
          statArrow="up"
          statPercent={info.countingPartnersProject ?? 0}
          statPercentColor="text-emerald-500"
          statDescripiron="projects"
          statDescripironTitle="Ongoing"
          statIconName="OperatorIcon"
          statIconColor="bg-[#CBDCDC]"
          styles="bg-white rounded mb-6 mt-6 xl:mb-0 shadow-lg px-2"
          systemSettings={systemSettings}
        />
      </div>
      {/* </div> */}

      <div className="grid lg:grid-cols-12 grid-cols-1 gap-4">
        <div className="col-span-7">
          <CardLineChart
            info={{ data: programData }}
            systemSettings={systemSettings}
          />
        </div>
        <div className="col-span-5">
          <CardBarChart info={info} systemSettings={systemSettings} />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        <AnnualLeave />
      </div>
    </>
  ) : (
    <div></div>
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
